const getDigit = string => {
  const reg = /\d+/
  return parseInt((string.match(reg)).toString())
}

const getCopyName = (string, copy) => {
  const stringArray = string.toString().split(`(${copy} `)
  if (stringArray[1]) {
    const size = parseInt(stringArray[1]) + 1
    return `${stringArray[0]}(${copy} ${size})`
  }
  return `${string} (${copy} 1)`
}

export {
  getDigit,
  getCopyName
}



// WEBPACK FOOTER //
// ./src/services/tools.js